
import * as ipxRuntime$_1kNODvvgWsatIRYVvaJgal2YyxMjwyu62CLvJMhSt80 from '/opt/build/repo/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as ipxStaticRuntime$YvlxRm6fFej_CHjXDf6FkpJCO096lWwCH4lWPm_tyvk from '/opt/build/repo/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1080,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$_1kNODvvgWsatIRYVvaJgal2YyxMjwyu62CLvJMhSt80, defaults: {} },
  ['ipxStatic']: { provider: ipxStaticRuntime$YvlxRm6fFej_CHjXDf6FkpJCO096lWwCH4lWPm_tyvk, defaults: {} }
}
        